<template>
  <div class="tg-qrcode-btn">
    <el-popover placement="top" width="140" v-model="showCode">
      <div class="tg-qrcode-btn--qrcode">
        <button type="button" class="closeIt" @click="handleClose"></button>
        <h5>{{ label }}</h5>
        <el-image :src="image" :alt="alt">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
      </div>
      <template slot="reference">
        <i :class="iconClass"></i>
      </template>
    </el-popover>
  </div>
</template>

<script>
import { on, off } from "element-ui/src/utils/dom";
export default {
  name: "TgQrcodeBtn",
  data() {
    return {
      showCode: false,
    };
  },
  props: {
    channel: {
      type: String,
      default: null,
    },
    role: {
      type: String,
      default: null,
    },
    refreshState: {
      type: Function,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    image: {
      type: String,
      default: null,
    },
    alt: {
      type: String,
      default: null,
    },
    size: String,
  },
  computed: {
    iconClass() {
      let classes = ["tg-icon", "tg-icon-circle"];

      if (this.size) {
        classes.push("tg-icon-" + this.size);
      }

      classes.push("tg-icon-" + this.channel);

      return classes;
    },
  },
  mounted() {
    on(document, "click", this.handleDocumentClick);
  },
  destroyed() {
    off(document, "click", this.handleDocumentClick);
  },
  methods: {
    handleDocumentClick(e) {
      if (!this.$el.contains(e.target)) {
        this.showCode = false;
      }
    },
    handleClose() {
      this.showCode = false;
    },
    close() {
      this.handleClose();
    },
  },
  watch: {
    showCode(val) {
      this.$emit("on-" + (val ? "show" : "close"), val);
    },
  },
};
</script>
